<template>
	<div v-bind:class="{ open: openSuggestion }">
		<input
			class="autocomplete-input"
			type="text"
			v-model="selection"
			@keydown.enter="enter"
			@keydown.down="down"
			@keydown.up="up"
			@input="change"
		/>
		<ul v-if="openSuggestion" class="autocomplete-results" style="position: relative; width: 100%">
			<li
				v-for="(suggestion, index) in matches"
				class="autocomplete-result"
				v-bind:class="{ active: isActive(index) }"
				:key="suggestion"
				@click="suggestionClick(index)"
			>
				<a href="#">{{ suggestion }}</a>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: "autocomplete",
	emits: ["change", "autocomplete"],
	props: {
		suggestions: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			open: false,
			current: 0,
			selection: "",
		};
	},
	computed: {
		//Filtering the suggestion based on the input
		matches() {
			return this.suggestions.filter((str) => {
				return str.indexOf(this.selection) >= 0;
			});
		},

		//The flag
		openSuggestion() {
			return this.selection !== "" && this.matches.length !== 0 && this.open === true;
		},
	},
	methods: {
		//When enter pressed on the input
		/*enter() {
      this.selection = this.matches[this.current];
      this.open = false;
    },*/

		//When up pressed while suggestions are open
		up() {
			if (this.current > 0) this.current--;
		},

		//When up pressed while suggestions are open
		down() {
			if (this.current < this.suggestions.length - 1) this.current++;
		},

		//For highlighting element
		isActive(index) {
			return index === this.current;
		},

		//When the user changes input
		change() {
			if (this.open === false) {
				this.open = true;
				this.current = 0;
			}
			this.$emit("change", this.selection);
		},

		cleanSelection() {
			this.selection = "";
		},

		//When one of the suggestion is clicked
		suggestionClick(index) {
			this.selection = this.matches[index];
			this.open = false;
			this.$emit("autocomplete", this.selection);
		},
	},
};
</script>

<style scoped>
.autocomplete-input {
	align-items: center;
	min-width: 200px;
	padding: 5px 4px 5px 7px;
	margin-right: 10px;
	margin-bottom: 9px;
	border-radius: 12px;
	font-size: 13px;
	font-weight: 700;
	border: 1px solid #cacaca;
	color: #8e8e8e;
	outline: 0;
}

.autocomplete-list {
	z-index: 10;
}

.autocomplete {
	position: relative;
}

.autocomplete-results {
	padding: 0;
	margin: 0;
	border: 1px solid #eeeeee;
	height: 120px;
	overflow: auto;
	width: 100%;
}

.autocomplete-result {
	list-style: none;
	text-align: left;
	padding: 4px 2px;
	cursor: pointer;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
	background-color: #33d1cd;
	color: white;
}
</style>
